import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './core/service/auth-guard.service';
import { BlacklisteComponent } from './pages/blackliste/blackliste.component';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './pages/login/login.component';
import { ProvisoireComponent } from './pages/provisoire/provisoire.component';

const routes: Routes = [
  {path: '', component: LoginComponent},
  {
    path : 'accueil',
    component: HomeComponent,canActivate: [AuthGuardService]
  },
  {
    path : 'login',
    component: LoginComponent
  },
  {path : 'blackliste',component:BlacklisteComponent,canActivate: [AuthGuardService]}
  
  ,  {path : 'provisoire',component:ProvisoireComponent,canActivate: [AuthGuardService]}
  ,
  {path: '**', redirectTo: ''},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
